const mobMenu = {
  nextLevel: document.querySelectorAll(
    '.jsNextLevel',
  ) as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(
    '.jsPrevLevel',
  ) as NodeListOf<HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,
  megamenuBtn: document.getElementById('jsToggleMegamenu') as HTMLElement, 
  megamenuWrap: document.getElementById('jsMegamenuWrap') as HTMLElement, 
  links: document.querySelectorAll('.jsDropdownBtns') as NodeListOf<HTMLElement>,
  overlay: document.getElementById('dropdownOverlay') as HTMLElement,
  searchBtn: document.getElementById('jsOpenSearch') as HTMLElement,
  headerBar: document.getElementById('jsHeaderBar') as HTMLElement,
  topLinks: document.querySelectorAll('.jsBarLink') as NodeListOf<HTMLElement>,

  init() {
    this.setNextLevel();
    this.setPrevLevel();
    this.toggleMegaMenu();
    this.menuOverlay();
    this.setBarLinks();
  },

  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement;
      if (subMenu) {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          subMenu.classList.add('activeClass');
        });
      }

      this.close.addEventListener('click', () => {
        subMenu.classList.remove('activeClass');
      });
    });
  },

  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement;
      if (menu) {
        item.addEventListener('click', () => {
          menu?.classList.remove('activeClass');
        });
      }
      this.close.addEventListener('click', () => {
        menu?.classList.remove('activeClass');
      });
    });
  },

toggleMegaMenu(): void {
  if (!this.megamenuBtn || !this.megamenuWrap) return;

  let closeTimer: number | undefined;
  const CLOSE_DELAY_MS = 140;

  const open = (): void => {
    if (closeTimer !== undefined) {
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    }
    this.megamenuWrap.classList.add('activeClass');
    this.megamenuBtn.classList.add('activeClass');
  };

  const close = (): void => {
    if (closeTimer !== undefined) window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout((): void => {
      this.megamenuWrap.classList.remove('activeClass');
      this.megamenuBtn.classList.remove('activeClass');
      closeTimer = undefined;
    }, CLOSE_DELAY_MS);
  };


  this.megamenuBtn.addEventListener('pointerenter', open);
  this.megamenuBtn.addEventListener('pointerleave', close);

  this.megamenuWrap.addEventListener('pointerenter', open);
  this.megamenuWrap.addEventListener('pointerleave', close);


  this.megamenuBtn.addEventListener('focusin', open);
  this.megamenuBtn.addEventListener('focusout', close);
},


menuOverlay(): void {
  let overlayTimer: ReturnType<typeof setTimeout> | null = null;

  this.links.forEach((item: HTMLElement) => {
    item.addEventListener('mouseenter', (): void => {
      if (overlayTimer !== null) {
        clearTimeout(overlayTimer);
      }

      overlayTimer = setTimeout((): void => {
        this.overlay?.classList.add('activeClass');
        overlayTimer = null;
      }, 250);
    });

    item.addEventListener('mouseleave', (): void => {
      if (overlayTimer !== null) {
        clearTimeout(overlayTimer);
        overlayTimer = null;
      }

      this.overlay?.classList.remove('activeClass');
    });
  });
},


setBarLinks() {
  const activeClass = 'activeClass';

  const closeAll = () => {
    this.topLinks.forEach((btn: Element) => {
      btn.classList.remove(activeClass);
    });
  };

  this.topLinks.forEach((btn: Element) => {
    btn.addEventListener('mouseenter', () => {
      closeAll();
      btn.classList.add(activeClass);
    });

    btn.addEventListener('mouseleave', () => {
      btn.classList.remove(activeClass);
    });
  });

  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target;

    if (!(target instanceof Element)) return;

    if (target.closest('.jsClose')) {
      closeAll();
      return;
    }

    const clickedInsideTopLink = Array.from(this.topLinks).some((btn: Element) =>
      btn.contains(target)
    );

    if (!clickedInsideTopLink) {
      closeAll();
    }
  });
}

};

export default mobMenu;
